import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {PlatformQuery} from "@shared/models/platform-query/platform-query";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {FuseSplashScreenService} from "@barebone-fuse/@fuse/services/splash-screen.service";
import {CommandService} from "@core/services/command.service";
import {FileManagementService} from "@core/services/file-management.service";
import { MagicLinkModel } from '@shared/models/platform-tool-models';
import { SnackBarService } from '@core/services/snack-bar.service';
import {VirtualGridApiService} from "@core/services/virtual-grid-api.service";

@Injectable({
  providedIn: 'root',
})

export class ExportToExcelCommandHandler implements IPlatformCommandHandler {
  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private commandService: CommandService,
    private fileManagementService: FileManagementService,
    private dialogService: DialogService,
    private snackBarService: SnackBarService,
    private virtualGridApiService: VirtualGridApiService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.fuseSplashScreenService.show();
    if (command.name === 'ExportToExcelCommand') {
      const sourceType = command.fieldValues['SourceType'];
      command.projectId = '[PROJECT_ID]';
      command.fieldValues['SortField'] = this.virtualGridApiService.getCurSortFieldKey(sourceType);
      command.fieldValues['SortDirection'] = this.virtualGridApiService.getCurSortDirection(sourceType);
    }
    if (command.name === 'BulkQnrExportCommand') {
      const sourceType = command.fieldValues['SourceType'];
      command.projectId = '[PROJECT_ID]';
      var directoryEntriesMappedToSortField = this.mapDirectoryEntriesToSortField(command);
      command.fieldValues['DirectoryEntriesMappedToSortField'] = directoryEntriesMappedToSortField;
      command.fieldValues['SortDirection'] = this.virtualGridApiService.getCurSortDirection(sourceType);
    }
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        console.log('Command Response', commandResponse);
        this.fuseSplashScreenService.hide();
        var snackbarErrorMessage = commandResponse.fieldValues['SnackBarErrorMessage'];
        if(snackbarErrorMessage)
        {
          this.snackBarService.showError(snackbarErrorMessage);
          return;
        }
        const downloadResponseModel = commandResponse.fieldValues['DownloadFileResponseModel'];

        if (!downloadResponseModel) {
          console.error('Download file response model not found.');
          return;
        }
        if((downloadResponseModel.hasError || downloadResponseModel.HasError) && (downloadResponseModel.message?.length > 0 || downloadResponseModel.Message?.length > 0)) {
          let errorMessage = downloadResponseModel.message;
          if (!errorMessage) errorMessage = downloadResponseModel.Message;
          this.snackBarService.showError(errorMessage);
          return;
        }
        let fileId = downloadResponseModel.fileId;
        if (!fileId) {
          // Note from Asir: in external command, FileId is coming as Camel Case !!!
          fileId = downloadResponseModel.FileId;
        }
        this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
          this.fuseSplashScreenService.hide();
          this.fileManagementService.openSaveFileWindow(payload, downloadResponseModel.fileName);
          if(command.fieldValues['IsQuestionnaireExport']){
            this.sendActivityForQuestionnairExport(command);
          }
        });
      },
      error => {
        console.error('Failed ToolBarComponent command', error);
        this.fuseSplashScreenService.hide();
      });
    return true;
  }
  mapDirectoryEntriesToSortField(command: PlatformCommand): any {
    var directoryEntriesMappedToSourceType = command.fieldValues["DirectoryEntiresMappedToSourceType"] as Record<string, string>;
    if (directoryEntriesMappedToSourceType == null) return;


    const directoryEntriesMappedToSortField: Record<string, string> = {};

    Object.entries(directoryEntriesMappedToSourceType).forEach(([directoryEntryId, sourceType]) => {
      const sortField = this.virtualGridApiService.getCurSortFieldKey(sourceType);
      const sortDirection = this.virtualGridApiService.getCurSortDirection(sourceType);
      directoryEntriesMappedToSortField[directoryEntryId] = sortField;
    });

    return directoryEntriesMappedToSortField;
  }

  private sendActivityForQuestionnairExport(command: PlatformCommand) {
    let activityCommand = this.getActivityCommandForQuestionnaireExportToExcel(command);
    this.commandService.executePlatformCommand(activityCommand).pipe(take(1)).subscribe(response => {
      console.log('activity Send');
    });
  }

  getActivityCommandForQuestionnaireExportToExcel(exportCommand) {
    let activityCommand = new PlatformCommand("TrackActivityForQuestionnaireGridCommand", "FileStoreApi");
    activityCommand.fieldValues['DirectoryId'] = exportCommand.fieldValues['DirectoryEntryId'];
    activityCommand.fieldValues['ChangeFieldType'] = ['ExportToExcel'];
    if (exportCommand.fieldValues['ScenarioId']) {
      activityCommand.fieldValues['CountryCode'] = exportCommand.basketId;
      activityCommand.fieldValues['ScenarioId'] = exportCommand.fieldValues['ScenarioId'];
      activityCommand.fieldValues['ScenarioType'] = exportCommand.fieldValues['ScenarioType'];
      activityCommand.fieldValues['QnrRelativePath'] = exportCommand.fieldValues['RelativePath'];
      activityCommand.fieldValues['ChangeFieldType'] = ['ExportToExcelForScenario'];
      if(exportCommand.fieldValues['PreviousUrl']){
        activityCommand.fieldValues['PreviousUrl'] = exportCommand.fieldValues['PreviousUrl'];
      }
    }
    return activityCommand;
  }
}
